import { render, staticRenderFns } from "./DetailSettlementDriver.vue?vue&type=template&id=2464c19a"
import script from "./DetailSettlementDriver.vue?vue&type=script&lang=js"
export * from "./DetailSettlementDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports